export const locale = {
    lang: "en-US",
    data: {
        NOTIFICATION: {
            TITLE: "Notification",

            APP_HAS_NOTIFICATIONS: "You have {{count}} notifications in the APP!",
            APP_HAS_NOTIFICATION: "You have 1 notification in the APP!",
            GO_TO_APP: "Go to the APP",

            CERTIFICATE_EXPORT_COMPLETED: "Certificates successfully exported!",
            USER_IMPORT_SUCCESS: "Users imported successfully!",
            USER_EXPORT_COMPLETED: "Users exported successfully!",
            DOWNLOAD: "DOWNLOAD"
        }
    }
};
